export default {
  data(){
    return{
      status_id_map: {
        "Active": 1,
        "Inactive": 2,
        "Suspended": 3,
        "Excluded": 4,
        "Canceled": 5,
        "Open": 6,
        "Payed": 7,
        "Overdue": 8,
        "Client limit warning": 9,
        "Client blocked": 10,
        "Computed": 11,
        "Protected": 12,
        "Set": 13,
        "Achieved": 14,
        "Missed": 15,
        "Concluded": 16,
        "Confirmed": 17,
        "Client blocked manually": 18,
        "Client blocked with invalid SPC": 19 ,
      }
    }
  }
}